import React,{useState, useEffect} from 'react'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import { makeStyles } from '@material-ui/core/styles';
import { Box,Card  ,CardContent ,Typography,
    InputLabel ,FormControl,LinearProgress,Tooltip,//,FormControlLabel
    Select as MaterialSelect, Grid } from '@material-ui/core'
import TablaPilDet from './TablaPilonaDetalle';
import axios from 'axios';
import qs from 'qs';

import {llamadaApiToken,llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';

import { SvgLoader, SvgProxy } from "react-svgmt";
const useStyles = makeStyles((theme)=>({
    root: {
      minWidth: 275,
    },    
    title: {
      fontSize: 28,
    },
    title2: {
        fontSize: 18,
      },
    subTitle2: {
        fontSize: 12,
    },    
    addButton: {
        marginRight: theme.spacing(2),       
    },
    altura2: {        
        marginTop:0,
        paddingTop:0,       
    },
    altura3: {
        minHeight: 100,
        marginTop:0,
        paddingTop:0,       
    },
    altura4: {
       // minHeight: 100,
        marginTop:0,
        paddingTop:0,       
    },
    altura1: {
        height: 90,        
    },
  }));
  
const PilonaDetalle = () => {
    let history = useHistory();
    const classes = useStyles();
    let nvlSNPermiso ='5'  
    let colorTitulo=process.env.REACT_APP_COLOR
    const colorBase1="#CAD3DB"
    const colorBase2="#00AFEF"
    const colorVerde="#51ad32"
    const source = axios.CancelToken.source();
    const idusu= localStorage.getItem('UsuId');
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {guardarGenerales}=React.useContext(GeneralesContext);          
    const [cabinaSelec, setCabinaSelec] =  useState([]);    
    const [listTipoDet, setListTipoDet] = useState({auxiliar:"",tecnico:""});    
    const [buscar, setBuscar] = useState(true);    
    const [terminal, setTerminal] = useState(1);        
 
    const [listLugarTerminal, setListLugarTerminal] = useState([])
    const [modalBitacora, setModalBitacora] = useState(false);
    const [actualizaPersnl, setActualizaPersnl] = useState(false);    
    const [espera2, setEspera2] = useState(false);                
    const [listPilona, setListPilona] = useState([]);    
    const [listPilonaOriginal, setListPilonaOriginal] = useState([]); 
    const [listDet, setListDet] = useState([]);    
    const [piezaRegis, setPiezaRegis]= useState([]);    
    const [engRegis, setEngRegis]= useState([]);    
    const [listRodillo, setListRodillo]= useState([]);    
    const [listEng, setListEng]= useState([]);    
    const [piloRegistro, setPiloRegistro] = useState([]);        

    useEffect(()=>{                              
        
		const veriSesion =  () => {            
            const usu= localStorage.getItem('UsuarioNom');
            const nvl= localStorage.getItem('Tipo');   
            if(usu==null)
            {                                
                guardarUsuario([])						
                guardarGenerales([])     
                localStorage.clear();           
                history.push("/")	
            }
            else{               
                if (usuario.length==0) 
                {
                    guardarUsuario({Nombre:usu,nivel:nvl});                                      
                }                
                guardarGenerales({Titulo:'Pilonas Balancin'})                        
             
                if (listLugarTerminal.length === 0) 
                {
                    llenarListTerminal();  
                }      
                getlistPilona(1)       
                getListTipoDet()
            }
        }
	    veriSesion();	    
        
        return ()=> {
            source.cancel();
        } 
    },[]);

    useEffect(()=>{
        if (listRodillo.length!==0) {
            const filtro = listRodillo.filter((elemnto)=> elemnto.Color ===colorVerde)    
            if (filtro.length!==0) {
                const Pieza = listDet.filter((detalle)=> detalle.Id === filtro[0].IdOriginal)                                
                setPiezaRegis(Pieza[0])
            }
        }
        
    },[listRodillo])
 
    
    useEffect(()=>{
        if (listEng.length!==0 ) {
            const filtro = listEng.filter((elemnto)=> elemnto.Color ===colorVerde )    
            if (filtro.length!==0) {
                const Pieza = listDet.filter((detalle)=> detalle.Id === filtro[0].IdOriginal)
                setEngRegis(Pieza[0])
            }
        }
        
    },[listEng])
 
    const llenarListTerminal = () => {      
        const data = qs.stringify({
            usuario:idusu,
            idDispositivo:'89y7gttvjhj98h'
        });
        const url = "/lugar-terminal-list";
        function respuestaListTermin(aux) {
            if (aux[0].Id !== -1) 
            {   let auxArre=[];   
                //console.log(aux);
                aux.map((tipo) => {
                    if (tipo.Id!=0) 
                    { auxArre.push({ value : tipo.Id, label :tipo.Descr })  
                    }            
                })    
            const auxTerm = localStorage.getItem('UsuTerminal') ;                
            const auxTerm2 = auxTerm!== null || auxTerm!== undefined ?  parseInt(auxTerm):1
            setListLugarTerminal(auxArre);  
            setTerminal(auxTerm2)
            }
        }            
        llamadaApiToken(data, url, respuestaListTermin,ErrorGeneral,history,source)
    };   

     const getListTipoDet = () => {      
        //console.log(cabinaSelec[0]);
        const data = qs.stringify({            
            Usuario:idusu ,
            idDispositivo:'89y7gttvjhj98h'
        });
        const url = "/pilona/tipo/balancin/det";
        function respuestaDetPers(auxiliar) {
            if (auxiliar ) 
            {
                setListTipoDet()
            }               
        }      
        llamaApiCargaToken(data, url,respuestaDetPers,ErrorGeneral,setEspera2,history,source);            
    };          

    const getlistPilona = (auxTerminal) => {      
        //console.log(cabinaSelec[0]);
        const data = qs.stringify({            
            usuario:idusu ,
            idDispositivo:'89y7gttvjhj98h'
        });
        const url = "/pilona-list";
        function respuestaDetPers(auxiliar) {
            if (auxiliar ) 
            { //console.log(auxiliar);
                const filtro = auxiliar.filter((pilona)=>pilona.TermId === auxTerminal)            
                
                if (filtro.length!==0 ) {
                    setListPilona(filtro)   
                    
                }
                setListPilonaOriginal(auxiliar) 
            }               
        }      
        llamaApiCargaToken(data, url,respuestaDetPers,ErrorGeneral,setEspera2,history,source);            
    }; 

     const getListDet = (auxPil) => {      
        
        const data = qs.stringify({            
            Usuario:idusu ,
            Pilona:auxPil,
            idDispositivo:'89y7gttvjhj98h'
        });
        const url = "/pilona/balancin";
        function respuestaDetPers(auxiliar) {
            if (auxiliar ) 
            {   let auxRodillo=[], auxEng=[]              
                auxiliar.forEach(element => {
                    
                    if (element.Clase ==="rodillo") {
                        auxRodillo.push({Id: element.Ord, Color: colorBase1, IdOriginal:element.Id})
                    }else{
                        auxEng.push({Id: element.Ord, Color: colorBase2, IdOriginal:element.Id})
                    }
                });         
                setListRodillo(auxRodillo)
                setListEng(auxEng)
                setListDet(auxiliar)                                                   
            }               
        }      
        llamaApiCargaToken(data, url,respuestaDetPers,ErrorGeneral,setEspera2,history,source);            
    }; 

    const onChangePilona = e =>
    {   
        setPiloRegistro(e)        
        getListDet(e.Id)  
        setListRodillo([])
        setListEng([])
        setListDet([])  
        setPiezaRegis([]);    
        setEngRegis([]);                              
    };
    
    const onChangeTerminal = (event) => 
    {   setTerminal(event.target.value);   

        
        const filtro = listPilonaOriginal.filter((pilona)=>pilona.TermId === parseInt(event.target.value))                        
        setListPilona(filtro)
        setListDet([]);    
        setPiezaRegis([]);    
        setEngRegis([]);    
        setListRodillo([]);    
        setListEng([]);    
        setPiloRegistro([]);        
    };  

    const incrementarBuscar = e =>
    {  setBuscar(!buscar)    
    };

    const actualizar2=()=>{
        setActualizaPersnl(!actualizaPersnl)
    }

    const limpiarArr=(lista, base, )=>{
        let nvoArr = []
        lista.forEach((campo)=>{
            nvoArr.push({Id: campo.Id, Color:base, IdOriginal:campo.IdOriginal })
        })
        return nvoArr
    }

    const colorGeneral=(elemnto, lista1, Base1, lista2, Base2, setLista1, setLista2)=>{
        const filtro = lista1.filter((valor)=>valor.Id !== elemnto.Id)
        const filtro2 = lista1.filter((valor)=>valor.Id === elemnto.Id)
        let nvo=[]
        if (filtro2[0].Color===Base1 ) {
            nvo={ Id:elemnto.Id,Color:colorVerde,  IdOriginal:filtro2[0].IdOriginal}
        }
        else{nvo={Id:elemnto.Id,Color:Base1, IdOriginal:filtro2[0].IdOriginal}}
        let listLimpia=limpiarArr(filtro, Base1, )
        let  listLimpia2=limpiarArr(lista2, Base2, )
        listLimpia.push(nvo)    
        
        setLista1(listLimpia)       
        setLista2(listLimpia2)       
    }

    const cambiaColor =(elemnto)=>{
 
        colorGeneral(elemnto, listRodillo, colorBase1, listEng, colorBase2, setListRodillo, setListEng)
    }
    
    const cambiaColor2 =(elemnto)=>{
       /*  const filtro = listEng.filter((valor)=>valor.Id !== elemnto.Id)
        const filtro2 = listEng.filter((valor)=>valor.Id === elemnto.Id)
        let nvo=[]
        if (filtro2[0].Color===colorBase2 ) {
            nvo={ Id:elemnto.Id,Color:colorVerde}
        }
        else{nvo={Id:elemnto.Id,Color:colorBase2}}
        let listLimpia=limpiarArr(filtro, colorBase2, )
        const listLimpia2=limpiarArr(listRodillo, colorBase1, )    
        listLimpia.push(nvo) 
                
        setListEng(listLimpia)       
        setListRodillo(listLimpia2)    
 */
        colorGeneral(elemnto, listEng, colorBase2, listRodillo, colorBase1, setListEng, setListRodillo)
    }

 

    const ladoDerecho=()=>{
        const nvoRuta=piloRegistro.BalWeb.replaceAll(" ","_")
        return(
        <Box pl={1} mt={.5} display={"flex"} flexDirection={"column"} style={{width:"640", height:"200"}} >            
            <SvgLoader 
                path={`ic_pilona/${nvoRuta}`}
                width="640" height="200" >
                <SvgProxy selector="ellipse" fill="#e6e6e6" />
                { listRodillo.length!== 0 ? 
                    listRodillo.map((elemento)=>{
                    return<SvgProxy
                            key={"#rodillo" +elemento.Id}
                            selector={"#rodillo" + elemento.Id + ",#rodillo" + elemento.Id + " path"}
                            //selector={"#rodillo" + elemento.Id}
                            //onmousedown={`console.log("Hello ${elemento.Id}")`}
                            //onmousedown={`${ imprime(elemento.Id)}`}
                            onmousedown={ ()=>{cambiaColor(elemento)}}
                            style={`fill:${elemento.Color}`}
                            
                        />
                    })
                :null }
                { listEng.length!== 0 ? 
                  listEng.map((elemento)=>{
                  return  <SvgProxy
                        key={"#pteng" + elemento.Id}
                        selector={"#pteng" + elemento.Id + ",#pteng" + elemento.Id + " path"}
                        //selector={"#rodillo" + elemento.Id}
                        //onmousedown={`console.log("Hello ${elemento.Id}")`}
                        //onmousedown={`${ imprime(elemento.Id)}`}
                        onmousedown={ ()=>{cambiaColor2(elemento)}}
                        style={`fill:${elemento.Color}`}
                        
                    />
                })
                :null }
            </SvgLoader>
            {listDet.length!==0 ? 
                <TablaPilDet listDet={listDet} piezaRegis={piezaRegis} listRodillo={listRodillo}
                    cambiaColor={cambiaColor} cambiaColor2={cambiaColor2} piloRegistro={piloRegistro}
                    setPiezaRegis={setPiezaRegis} engRegis={engRegis} setEngRegis={setEngRegis} /> 
            :null}
        </Box>)   
    }


const contenido2 = piloRegistro.length !== 0 ? (ladoDerecho) : null
const principal=()=>{

    return(
        <Box display="flex" flexDirection="column" >
        
            <Box  display="flex" flexDirection="row">   
                <Box width="40%"  pt={1} >
                {listLugarTerminal.length!=0 ?  
                    <FormControl className={classes.formControl} size="small" style={{width:8+'rem', marginLeft:"1rem", marginBottom:"1rem"}}>
                    <InputLabel htmlFor="terminal1-native-simple">Terminal</InputLabel>
                    <MaterialSelect
                        native value={terminal} onChange={onChangeTerminal}
                        inputProps={{ name: 'terminal', id: 'terminal'}}
                    >
                        <option aria-label="None" value="" />      
                        {listLugarTerminal.map((row) => (
                            <option value={row.value}>{row.label}</option>
                        ))}   
                    </MaterialSelect>
                    </FormControl>     
                :null} 
                {  listPilona.length!==0 ? 
                    <Grid container >
                        {listPilona.map((pilona)=>{
                            const aux= piloRegistro.length!==0 &&  piloRegistro.Id=== pilona.Id ? {backgroundColor:"green",color:"white"}:{}
                            return(
                            <Grid item xs={2} style={{margin:".7rem"}} >
                            <Card key={pilona.Id} style={{width:"6.5rem", height:"4rem",...aux}}
                                onClick={()=>onChangePilona(pilona)} 
                            >
                                <CardContent style={{padding:"0",margin:"0", textAlign:"center"}}>
                                    <Box display="flex" flexDirection={"row"}  
                                        style={{alignItems:"center",justifyContent:"center", paddingRight:".4rem", paddingLeft:".4rem",marginTop:".5rem"}}>
                                    <Typography component="p" variant="body2" style={{marginRight:"1rem"}} >
                                        {pilona.Folio}
                                    </Typography>  
                                    <Card style={{background:"#51ad32", color:"white",width:"2rem",textAlign:"right"}}>
                                        <Typography component="p" variant="body2" style={{margin:".2rem"}} >
                                            {pilona.BalNom}
                                        </Typography> 
                                    </Card>
                                    </Box>
                                    <Typography component="p" variant="body2" style={{marginBottom:".5rem"}} >
                                        {pilona.TipoNom}
                                    </Typography>  
                                </CardContent>
                            </Card>
                            </Grid>
                            )
                        })}
                    </Grid>     
                :null}       
            
                </Box> 
          {/*       <Box width="40%"  pt={1} >                                                                            
                                                        
                </Box>  */}                   
                <Box width="60%"   >                        
                    {contenido2}
                </Box> 
            </Box>                
        </Box>      
    )
}

    return (
    <div>
        {principal()}
       
    </div>
    )
}

export default PilonaDetalle
